import React from 'react';
import { Outlet } from 'react-router-dom';
import UserSidebar from './UserSidebar';
import UserTopBar from './UserTopBar';

const UserLayout = () => {
  return (
    <div className="flex bg-gray-50 min-h-screen">
      <UserSidebar />
      <div className="flex-1 flex flex-col min-w-0 pt-16 lg:pt-0">
        <UserTopBar />
        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default UserLayout;
